// @flow
import styled from 'styled-components';

export const Match = styled.div`
  white-space: normal;

  small {
    opacity: 0.8;
    padding-top: 3px;
    line-height: 1.3em;
  }
`;
